import { assignLabor, enqueue } from '../sim'
import type { Command } from '../sim'

// Assignment input adapter. Mirrors place.ts: input never mutates sim state —
// it only appends a typed assign_labor command to the queue for the phase-1
// drain to validate. There is no per-unit UI; assignment is chain-level only.
//
// assign_labor carries an ABSOLUTE target, so a +1/-1 keypress is resolved
// against the chain's current target HERE into the new absolute count (floored
// at zero) and enqueued. The caller supplies the current target it reads from
// its view, so this stays a pure queue-append with no live sim read.

/**
 * Enqueue an assign_labor command that nudges chain `chain`'s target by `delta`
 * (typically +1 or -1), floored at zero. Returns the new absolute target the
 * command carries so the caller can echo it in a readout without waiting for the
 * next drain.
 */
export function enqueueAssignDelta(
  queue: Command[],
  chain: number,
  currentTarget: number,
  delta: number,
): number {
  const next = Math.max(0, Math.floor(currentTarget) + delta)
  enqueue(queue, assignLabor(chain, next))
  return next
}
